<template>
  <transition name="slide-fade" appear>
    <div
      v-if="!isDismissed"
      class="notification"
      :class="{
        'notification--black notification--colored': isBlack,
        'notification--blue notification--colored':
          isColored && alertType === 'Information',
        'notification--green notification--colored':
          isColored && alertType === 'Notice',
        'notification--yellow notification--colored':
          isColored && alertType === 'Warning',
        'notification--orange notification--colored':
          isColored && alertType === 'Critical',
      }"
    >
      <div class="notification__inner">
        <div class="notification__left">
          <div class="notification__left-icon">
            <i
              v-if="alertType === 'Information' && !isColored"
              class="icon icon-info-circle-colour icon--xs"
              aria-hidden="true"
            />
            <i
              v-if="alertType === 'Notice' && !isColored"
              class="icon icon-alert-success-colour icon--xs"
              aria-hidden="true"
            />

            <i
              v-if="alertType === 'Critical' && !isColored"
              class="icon icon-alert-circle-colour icon--xs"
              aria-hidden="true"
            />
            <i
              v-if="alertType === 'Warning' && !isColored"
              class="icon icon-alert-triangle-colour icon--xs"
              aria-hidden="true"
            />

            <i
              v-if="alertType === 'Information' && isColored"
              class="icon icon-info-circle-white icon--xs"
              aria-hidden="true"
            />
            <i
              v-if="alertType === 'Notice' && isColored"
              class="icon icon-alert-success-white icon--xs"
              aria-hidden="true"
            />

            <i
              v-if="alertType === 'Critical' && isColored"
              class="icon icon-alert-circle-white icon--xs"
              aria-hidden="true"
            />
            <i
              v-if="alertType === 'Warning' && isColored"
              class="icon icon-alert-triangle-white icon--xs"
              aria-hidden="true"
            />
          </div>
          <div class="notification__left-content">
            <p>
              <span v-if="heading" class="text--bold">{{ heading }}</span>
              {{ mainBody }}
            </p>
            <a
              v-if="linkLabel && linkHref"
              class="link paragraph-note text--underlined"
              v-bind:href="linkHref"
              v-bind:aria-label="[
                linkAssistiveText ? linkAssistiveText : linkLabel,
              ]"
              @blur="
                (e) => {
                  emitHandler('elBlur', e);
                }
              "
              @focus="
                (e) => {
                  emitHandler('elFocus', e);
                }
              "
            >
              {{ linkLabel }}
            </a>
          </div>
        </div>

        <div
          v-if="!isNotDismissible || (secondaryLinkLabel && secondaryLinkHref)"
          class="notification__right"
        >
          <a
            v-if="secondaryLinkLabel && secondaryLinkHref"
            v-bind:href="secondaryLinkHref"
            v-bind:aria-label="[
              secondaryLinkAssistiveText
                ? secondaryLinkAssistiveText
                : secondaryLinkLabel,
            ]"
            class="link link--text paragraph-note"
            @blur="
              (e) => {
                emitHandler('elBlur', e);
              }
            "
            @focus="
              (e) => {
                emitHandler('elFocus', e);
              }
            "
          >
            {{ secondaryLinkLabel }}
          </a>
          <button
            v-if="!isNotDismissible"
            role="button"
            aria-label="Dismiss notification"
            class="button--text button--icon"
            @click="dismissBanner"
            @blur="
              (e) => {
                emitHandler('elBlur', e);
              }
            "
            @focus="
              (e) => {
                emitHandler('elFocus', e);
              }
            "
          >
            <i class="icon icon-close icon--xxxs" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref } from 'vue';

const emitHandler = (name, e) => {
  emit(name, e);
};

const emit = defineEmits(['wasDismissed', 'elBlur', 'elFocus']);

const dismissBanner = (e) => {
  emit('wasDismissed', e);
};

const props = defineProps({
  alertType: {
    type: String,
    default: 'None',
    validator(value) {
      // The value must match one of these strings
      return ['None', 'Information', 'Notice', 'Warning', 'Critical'].includes(
        value,
      );
    },
  },
  heading: {
    type: String,
    default: '',
  },
  mainBody: {
    // xHtmlString
    type: undefined,
    default: '',
  },
  linkLabel: {
    type: String,
    default: '',
  },
  linkAssistiveText: {
    type: String,
    default: '',
  },
  linkHref: {
    type: String,
    default: '',
  },
  secondaryLinkLabel: {
    type: String,
    default: '',
  },
  secondaryLinkAssistiveText: {
    type: String,
    default: '',
  },
  secondaryLinkHref: {
    type: String,
    default: '',
  },
  isNotDismissible: {
    type: Boolean,
    default: false,
  },
  isColored: {
    type: Boolean,
    default: false,
  },
  isBlack: {
    type: Boolean,
    default: false,
  },
  isDismissed: {
    type: Boolean,
    default: false,
  },
});
</script>
